/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSouscriptionWaiverStagesQuery from '../graphql/queries/GetSouscriptionWaiverStagesQuery.js';

const useGetSouscriptionWaiverStagesQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSouscriptionWaiverStagesQuery, args);

  return {
    error,
    loading,
    refetch,
    getSouscriptionWaiverStages: R.omit(['__typename'], data?.getSouscriptionWaiverStages_souscription_waiver_stages || {})
  };
};

export default useGetSouscriptionWaiverStagesQuery;
